'use client'

import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSliders } from '@awesome.me/kit-94e593bf23/icons/classic/light'
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom'

import RandomProductImage from '@/app/_components/RandomProductImage'

const CategoryNav = dynamic(() => import('./CategoryNav'), { ssr: false })

const CategoryBrand = ({ category }) => {

    // Children are now pre-sorted arrays from PHP cache
    const children = category.children || []

    return (
        <div className="flex flex-col lg:flex-row align-start">
            <aside className="relative flex flex-col items-start h-full hidden lg:block w-[225px] min-w-[225px] mr-12 pt-4">
                <div className="flex items-center border-b-1 border-gray-8 pb-3">
                    <FontAwesomeIcon icon={faSliders} className="text-primary text-xl mr-3" width="16" />
                    <span className="text-md text-primary">Filter</span>
                </div>
                <CategoryNav category={category} />
            </aside>
            <div className="pb-[150px] w-full pt-4">
                <div className="flex items-center mb-3">
                    <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-xl mr-1" />
                    <h1 className="text-xl text-light font-extralight block">{category.display_name || category.category_name}</h1>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-y-10 md:gap-y-14 gap-x-6 md:gap-x-10 2xl:gap-x-20">
                    {children.map((subCategory, index) => (
                        <Link key={subCategory.category_id || index} href={subCategory.url} className="group">
                            <div className="group relative w-full overlay-block aspect-[5/4] md:aspect-[10/8.5] mb-2">
                                {subCategory.active_sale && (
                                    <div className="absolute top-0 left-0 z-20 p-2 font-medium text-sm text-red">
                                        Sale
                                    </div>
                                )}
                                {subCategory.images?.brand_logo_right?.file_name &&
                                    <Image
                                        className="absolute top-3 right-2 md:top-6 md:right-4 z-10 max-w-[70%] md:max-w-[45%] lg:max-w-[55%] max-h-[30%] md:max-h-[35%] lg:max-h-[40%] w-auto h-auto object-contain origin-top-right"
                                        src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subCategory.images.brand_logo_right.file_name}`}
                                        overrideSrc={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subCategory.images.brand_logo_right.file_name}`}
                                        alt={subCategory.images.brand_logo_right.alt || subCategory.category_name}
                                        width={subCategory.images.brand_logo_right.width}
                                        height={subCategory.images.brand_logo_right.height}
                                    />
                                }
                                <RandomProductImage
                                    images={subCategory.featured_product_images}
                                    className="absolute block bottom-2 left-2 md:bottom-4 md:left-4 z-0 max-w-[75%] md:max-w-[50%] max-h-[60%] md:max-h-[55%] w-auto h-auto object-contain"
                                    alt={subCategory.category_name}
                                    width={200}
                                    height={200}
                                />
                            </div>
                            <div className="flex justify-between items-baseline mt-2">
                                <span className="text-lg group-hover:text-primary">{subCategory.category_name}</span>
                                {subCategory.active_sale?.sale_title && (
                                    <span className="text-red text-lg">{subCategory.active_sale.sale_title}</span>
                                )}
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CategoryBrand
